<span class="kind-tag" data-testid="action-kind-tag" aria-hidden="true">{{ kindTag() }}</span>
<!-- size="small" is required by hive-inline-notification, which console.errors on any other size
     when a button is projected into it — and the callout renders through that component. -->
<hive-button size="small" [emphasis]="emphasis()" [label]="action().label" (click)="activateAction()" />
